export const pt = {
  brandName: "Docs Organizer",
  loading: "Já vamos… a acordar os bits ☕",

  // Auth
  authTagline:
    "Entra aí, deixa as faturas connosco e respira. A tua papelada fica só para ti.",
  signIn: "Entrar",
  createAccount: "Criar conta",
  name: "Nome",
  nameOptional: "Opcional — ou inventa um codinome giro",
  email: "Email",
  password: "Palavra-passe",
  pleaseWait: "Um segundinho…",
  authFailed: "Ups — isto não bateu certo. Tenta outra vez?",
  orContinueWith: "ou continua com",
  continueGoogle: "Google",
  continueFacebook: "Facebook",
  continueGitHub: "GitHub",

  // Language
  language: "Idioma",
  languagePt: "Português",
  languageEn: "English",
  languageHintGuest: "Guardamos isto só nesta sessão do browser.",
  languageHintUser: "Guardámos a tua escolha na conta. Sempre que entrares, falamos assim.",
  languageSaved: "Pronto! Já falamos nesta língua.",

  // App shell
  appTagline:
    "O teu cantinho privado — larga faturas e recibos. Nós lemos, tu só confirmas.",
  manageUsers: "Gerir utilizadores",
  manageTeams: "Gerir equipas",
  exportCsv: "Exportar CSV",
  refresh: "Atualizar",
  signOut: "Sair",

  // Dropzone
  dropTitle: "Larga as faturas aqui",
  dropTitleActive: "Solta — nós apanhamos!",
  dropHint: "PDF, PNG, JPG… ou clica se fores da antiga",
  uploading: "A enviar… não fujas!",
  queuedOcr: "Na fila do OCR — a máquina já está a esfregar as mãos",
  processing: "A processar",

  // List / search
  searchPlaceholder: "Procura fornecedor, nº da fatura, ficheiro…",
  searchAria: "Pesquisar documentos",
  filterStatusAria: "Filtrar por estado",
  allStatuses: "Todos os estados",
  statusUploaded: "Enviado",
  statusQueued: "Na fila",
  statusProcessing: "A processar",
  statusCompleted: "Concluído",
  statusFailed: "Falhou",
  noDocuments: "Ainda não há nada aqui. Larga um ficheiro e começa a festa.",
  loadingDocs: "A carregar a tua papelada…",
  unknownVendor: "Fornecedor misterioso",
  noDate: "Sem data",

  // Detail
  selectDocument: "Escolhe um documento à esquerda. Ou larga um novo — nós não julgamos.",
  ocrProgress: "OCR a trabalhar ({progress}%)",
  fieldVendor: "Fornecedor",
  fieldInvoiceNumber: "Nº da fatura",
  fieldInvoiceDate: "Data da fatura",
  fieldDueDate: "Data de vencimento",
  fieldCurrency: "Moeda",
  fieldTotal: "Total",
  fieldTax: "IVA / Imposto",
  fieldSubtotal: "Subtotal",
  fieldNif: "NIF / VAT",
  fieldCategory: "Categoria",
  fieldNotes: "Notas",
  rawText: "Texto do OCR (cru e sem filtro)",
  saveFields: "Guardar campos",
  rerunOcr: "Correr OCR outra vez",
  reparse: "Re-ler campos",
  openFile: "Abrir ficheiro",
  delete: "Apagar",

  // Errors (fallback funny)
  failedLoad: "Não conseguimos carregar isto. A internet foi tomar um café?",
  uploadFailed: "O envio falhou. Tenta outra vez — a segunda é de ouro.",
  openFailed: "Não abrimos esse documento. Estranho…",
  saveFailed: "Não guardámos. Culpa nossa (provavelmente).",
  ocrFailed: "O OCR fez birra e não arrancou.",
  reparseFailed: "A re-leitura falhou. Os campos estão teimosos hoje.",
  deleteFailed: "Não apagámos. O ficheiro agarrou-se à vida.",
  exportFailed: "O CSV recusou-se a sair. Drama.",

  // Admin users
  adminUsersTitle: "Gerir utilizadores",
  adminUsersSubtitle: "Cria contas, muda roles e reinicia palavras-passe sem drama.",
  backToArchive: "Voltar ao arquivo",
  users: "Utilizadores",
  totalCount: "{count} no total",
  createUser: "Criar utilizador",
  roles: "Roles",
  roleUser: "User",
  roleSuperUser: "Super User",
  roleTeamMember: "Team Member",
  editUser: "Editar utilizador",
  selectUser: "Escolhe um utilizador para editar.",
  resetPassword: "Nova palavra-passe",
  resetPasswordHint: "Deixa em branco se quiseres manter a atual",
  saveChanges: "Guardar alterações",
  createFailed: "Criação falhou. Confere o email e tenta outra vez.",
  updateFailed: "Atualização falhou. Algo correu ao lado.",

  // Admin teams
  adminTeamsTitle: "Gerir equipas",
  adminTeamsSubtitle:
    "Equipas podem estar vazias ou só com gente que tem o role Team Member.",
  teams: "Equipas",
  createTeam: "Criar equipa",
  description: "Descrição",
  editTeam: "Editar equipa",
  selectTeam: "Escolhe uma equipa para editar.",
  membersTeamOnly: "Membros (só Team Member)",
  noTeamMembersYet:
    "Ainda ninguém tem o role Team Member. Vai a Gerir utilizadores e marca alguém.",
  saveTeam: "Guardar equipa",
  deleteTeam: "Apagar equipa",
  deleteTeamConfirm: "Apagar a equipa “{name}”?",
  noTeamsYet: "Ainda não há equipas. Cria a primeira!",
  memberCount: "{count} membro",
  memberCountPlural: "{count} membros",
  loadTeamsFailed: "Não carregámos as equipas. Azar do dia.",
  loadUsersFailed: "Não carregámos os utilizadores. Azar do dia.",
} as const;

export type MessageKey = keyof typeof pt;

export const en: Record<MessageKey, string> = {
  brandName: "Docs Organizer",
  loading: "Hang on… waking up the bits ☕",

  authTagline:
    "Hop in, dump the invoices on us, and breathe. Your paperwork stays yours only.",
  signIn: "Sign in",
  createAccount: "Create account",
  name: "Name",
  nameOptional: "Optional — or invent a cool codename",
  email: "Email",
  password: "Password",
  pleaseWait: "One sec…",
  authFailed: "Nope, that didn’t match. Try again?",
  orContinueWith: "or continue with",
  continueGoogle: "Google",
  continueFacebook: "Facebook",
  continueGitHub: "GitHub",

  language: "Language",
  languagePt: "Português",
  languageEn: "English",
  languageHintGuest: "We only remember this for this browser session.",
  languageHintUser: "Saved on your account. We’ll speak this way every time you log in.",
  languageSaved: "Nice! We’ll talk like this from now on.",

  appTagline:
    "Your private corner — drop invoices and receipts. We read them, you just nod along.",
  manageUsers: "Manage users",
  manageTeams: "Manage teams",
  exportCsv: "Export CSV",
  refresh: "Refresh",
  signOut: "Sign out",

  dropTitle: "Drop invoices here",
  dropTitleActive: "Release — we got this!",
  dropHint: "PDF, PNG, JPG… or click if you’re old-school",
  uploading: "Uploading… don’t run away!",
  queuedOcr: "Queued for OCR — the machine is rubbing its hands",
  processing: "Processing",

  searchPlaceholder: "Search vendor, invoice #, filename…",
  searchAria: "Search documents",
  filterStatusAria: "Filter by status",
  allStatuses: "All statuses",
  statusUploaded: "Uploaded",
  statusQueued: "Queued",
  statusProcessing: "Processing",
  statusCompleted: "Completed",
  statusFailed: "Failed",
  noDocuments: "Nothing here yet. Drop a file and let’s get this party started.",
  loadingDocs: "Loading your paperwork…",
  unknownVendor: "Mystery vendor",
  noDate: "No date",

  selectDocument: "Pick a document on the left. Or drop a new one — we don’t judge.",
  ocrProgress: "OCR grinding away ({progress}%)",
  fieldVendor: "Vendor",
  fieldInvoiceNumber: "Invoice #",
  fieldInvoiceDate: "Invoice date",
  fieldDueDate: "Due date",
  fieldCurrency: "Currency",
  fieldTotal: "Total",
  fieldTax: "Tax / VAT",
  fieldSubtotal: "Subtotal",
  fieldNif: "Tax ID / VAT",
  fieldCategory: "Category",
  fieldNotes: "Notes",
  rawText: "Raw OCR text (unfiltered chaos)",
  saveFields: "Save fields",
  rerunOcr: "Run OCR again",
  reparse: "Re-parse fields",
  openFile: "Open file",
  delete: "Delete",

  failedLoad: "Couldn’t load that. Did the internet go for coffee?",
  uploadFailed: "Upload failed. Second time’s the charm.",
  openFailed: "Couldn’t open that document. Weird…",
  saveFailed: "Didn’t save. Probably our fault.",
  ocrFailed: "OCR threw a tantrum and refused to start.",
  reparseFailed: "Re-parse failed. Those fields are stubborn today.",
  deleteFailed: "Didn’t delete. That file clung to life.",
  exportFailed: "CSV refused to leave. Drama.",

  adminUsersTitle: "Manage users",
  adminUsersSubtitle: "Create accounts, tweak roles, reset passwords — no drama.",
  backToArchive: "Back to archive",
  users: "Users",
  totalCount: "{count} total",
  createUser: "Create user",
  roles: "Roles",
  roleUser: "User",
  roleSuperUser: "Super User",
  roleTeamMember: "Team Member",
  editUser: "Edit user",
  selectUser: "Pick a user to edit.",
  resetPassword: "Reset password",
  resetPasswordHint: "Leave blank to keep the current one",
  saveChanges: "Save changes",
  createFailed: "Create failed. Check the email and try again.",
  updateFailed: "Update failed. Something went sideways.",

  adminTeamsTitle: "Manage teams",
  adminTeamsSubtitle:
    "Teams can be empty, or only include folks with the Team Member role.",
  teams: "Teams",
  createTeam: "Create team",
  description: "Description",
  editTeam: "Edit team",
  selectTeam: "Pick a team to edit.",
  membersTeamOnly: "Members (Team Member role only)",
  noTeamMembersYet:
    "Nobody has the Team Member role yet. Hit Manage users and tick someone.",
  saveTeam: "Save team",
  deleteTeam: "Delete team",
  deleteTeamConfirm: "Delete team “{name}”?",
  noTeamsYet: "No teams yet. Create the first one!",
  memberCount: "{count} member",
  memberCountPlural: "{count} members",
  loadTeamsFailed: "Couldn’t load teams. Rough day.",
  loadUsersFailed: "Couldn’t load users. Rough day.",
};
